<template>
    <Button
        @click="isOpen = true"
        iconName="paper-plane"
        iconClass="w-3.5 h-3.5"
        color="dark"
    >
        Invite
    </Button>

    <Drawer
        @close="isOpen = false"
        :show="isOpen"
    >
        <template #title> Create </template>
        <template #content>
            <ApiForm
                :url="RoutePathAppEnum.CompanyUsers_Invites_Send"
                method="POST"
                ref="apiFormRef"
            >
                <CompanyUserInviteForm
                    :errors="
                        apiFormRef?.response?.getErrors() ??
                        new ApiFormErrors({})
                    "
                />
            </ApiForm>
        </template>
        <template #actions>
            <Button
                @click="isOpen = false"
                color="light"
            >
                Cancel
            </Button>
            <Button
                @click="submit"
                iconName="save"
                :loading="apiFormRef?.loading.valueOf()"
            >
                Save
            </Button>
        </template>
    </Drawer>
</template>

<script setup lang="ts">
    import { ref } from 'vue'
    import CompanyUserInvite from '@/App/CompanyUserInvite/Entity/CompanyUserInvite'
    import Drawer from '@/Shared/Component/Drawer.vue'
    import Button from '@/Shared/Component/Button.vue'
    import ApiForm from '@/Shared/Component/Forms/ApiForm.vue'
    import CompanyUserInviteForm from '@/App/CompanyUserInvite/Component/CompanyUserInviteForm.vue'
    import type { ApiFormRefType } from '@/Shared/AutoGenerated/Types'
    import ApiFormErrors from '@/Shared/Component/Forms/ApiFormErrors'
    import ApiFormResponseType from '@/Shared/Component/Forms/ApiFormResponseType'
    import { ResponseJsonKeyEnum } from '@/Shared/AutoGenerated/Main'
    import { RoutePathAppEnum } from '@/Shared/AutoGenerated/RoutePathEnum'

    const emits = defineEmits<{
        onSuccess: [companyUserInvite: CompanyUserInvite]
    }>()

    const isOpen = ref<boolean>(false)
    const apiFormRef = ref<ApiFormRefType>(null)

    const submit = () => {
        apiFormRef.value?.submit()?.then((response: ApiFormResponseType) => {
            const companyUserInvite = CompanyUserInvite.hydrateSingle(
                response.getObjectFromPayload(
                    ResponseJsonKeyEnum.App_CompanyUserInvite_Send_CompanyUserInviteData,
                ),
            )

            emits('onSuccess', companyUserInvite)
            isOpen.value = false
        })
    }
</script>
